import { useState, useEffect } from "react"
import { ICheckBooleanFieldProperties } from "../fields"

export const CheckBooleanField = (props: ICheckBooleanFieldProperties) => {
  const [value, setValue] = useState(props.value)

  useEffect(() => {
    setValue(props.value)
  }, [props.value])

  const handleOnValueChange = () => {
    setValue(!value)
    if (typeof props.onChange === "function") {
      props.onChange(props.name, !value, false)
    }
  }

  return (
    <div className={"ocs-field-container h-100 d-flex align-items-end"}>
      <label
        className={
          "ocs-check-container d-flex align-items-center" +
          (props.disabled ? " ocs-check-disabled" : "")
        }
      >
        <input
          type="checkbox"
          onChange={() => handleOnValueChange()}
          checked={value}
          disabled={props.disabled}
        />
        <span className="ocs-checkmark-check" />
        <span className="ocs-label">{props.caption}</span>
      </label>
    </div>
  )
}
